<template>
  <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mt-3 d-flex">
    <article class="app-item p-2">
      <div class="row px-half pb-3">
        <div class="col-5">
          <div class="thumbnail">
            <template v-if="item">
              <img :src="metadata.appIcon" class="clickable full-height" v-if="metadata && metadata.appIcon" @click="selectApp" />
              <div class="img-empty bg-grey4 p-3" @click="selectApp" v-else>
                <img :src="publicPath + require('@/core/assets/Integration/calendar.svg')" />
              </div>
            </template>
            <template v-else>
              <div class="img-empty empty" v-if="!comingSoon"></div>

              <div class="img-empty bg-grey4 p-3" v-else>
                <img :src="publicPath + require('@/core/assets/Integration/calendar.svg')" />
              </div>
            </template>
          </div>
        </div>
        <div class="col-7">
          <div class="bundles">
            <Tag v-for="(w, _i) in bundle" :key="item.id + '__' + _i" :item="w" @select="selectTag" />
          </div>
        </div>
      </div>
      <div class="info px-half pb-2">
        <h6 class="typo-heading20 typo-medium mb-1" v-if="item">
          <span class="clickable" v-if="item" @click="selectApp">{{ item.label }}</span>
        </h6>
        <template v-else>
          <h6 class="typo-heading20 typo-medium mb-2 mt-half text-grey2" v-if="comingSoon">
            {{ $t("integration.soon") }}
          </h6>
          <h6 class="typo-heading20 typo-medium mb-2 mt-half" v-else :style="`width: ${40 + Math.random() * 30}%;`"></h6>
        </template>
        <p class="content typo-paragraph14 typo-regular-150 text-light-low mb-4" v-if="item" v-html="item.short_desc">
        </p>
        <template v-else>
          <p class="content typo-paragraph14 typo-lh150 text-grey2 mb-2 paragraph" :class="{ empty: !comingSoon, 'bg-grey3': comingSoon }" v-for="ind in 3" :key="'loading_p_' + ind" />
          <p class="content typo-paragraph14 typo-lh150 text-grey2 mb-2 paragraph" :class="{ empty: !comingSoon, 'bg-grey3': comingSoon }" :style="`width: ${50 + Math.random() * 30}%;`" />
        </template>
      </div>
      <div class="footer row justify-content-between mt-auto pt-half">
        <div class="col-12 col-xs-12 col-sm-6 col-lg-6 col-xl-6 align-items-center d-flex">
          <span class="rating flex-v-center">
            <svg width="20" height="22" class="mr-1" viewBox="0 0 20 22" fill="none" :class="{ 'text-grey3': comingSoon }">
              <g clip-path="url(#rating-star)">
                <path d="M19.6291 8.05486C19.5401 7.80434 19.3802 7.58823 19.1709 7.43537C18.9615 7.28252 18.7126 7.2002 18.4574 7.19941H13.3849C13.2986 7.19947 13.2144 7.17146 13.1439 7.11923C13.0735 7.067 13.0202 6.99314 12.9916 6.90786L11.1708 1.50192C11.0816 1.25206 10.9217 1.03669 10.7124 0.884647C10.5032 0.732599 10.2546 0.651123 9.99992 0.651123C9.74526 0.651123 9.49668 0.732599 9.28743 0.884647C9.07819 1.03669 8.91828 1.25206 8.82909 1.50192L8.82492 1.51589L7.00826 6.90786C6.97965 6.993 6.92654 7.06676 6.85624 7.11898C6.78595 7.17119 6.70193 7.19929 6.61576 7.19941H1.54159C1.28477 7.19921 1.03413 7.28187 0.823742 7.43616C0.61336 7.59045 0.453451 7.80887 0.365766 8.06172C0.27808 8.31457 0.266873 8.58957 0.33367 8.84933C0.400466 9.10909 0.542024 9.34099 0.739089 9.51349L5.05909 13.267C5.12371 13.3232 5.17062 13.3985 5.19367 13.4831C5.21672 13.5677 5.21483 13.6576 5.18826 13.741L3.37326 19.442C3.28938 19.7056 3.28772 19.9903 3.36853 20.2549C3.44933 20.5196 3.60841 20.7504 3.82275 20.9141C4.03709 21.0778 4.29559 21.1658 4.56084 21.1654C4.82609 21.165 5.08435 21.0763 5.29826 20.912L9.75326 17.4902C9.82469 17.4353 9.91095 17.4058 9.99951 17.4058C10.0881 17.4058 10.1743 17.4353 10.2458 17.4902L14.6991 20.9111C14.9129 21.0759 15.1713 21.1652 15.4368 21.1659C15.7023 21.1667 15.9611 21.0788 16.1757 20.9152C16.3904 20.7515 16.5497 20.5205 16.6306 20.2556C16.7115 19.9908 16.7098 19.7058 16.6258 19.442L14.8108 13.7375C14.7842 13.6541 14.7823 13.5642 14.8053 13.4796C14.8284 13.395 14.8753 13.3197 14.9399 13.2635L19.2683 9.50477C19.4628 9.3308 19.6017 9.0985 19.6662 8.83922C19.7308 8.57995 19.7178 8.30618 19.6291 8.05486Z" fill="currentColor" />
              </g>
              <defs>
                <clipPath id="rating-star">
                  <path d="M0 0.435303H20V21.3852H0V0.435303Z" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <span class="rating-points typo-button14 typo-medium" :class="{ 'omit-empty': comingSoon }">
              <template v-if="item">{{ metadata.ratingPoints || 0 }}</template>
            </span>
          </span>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-lg-6 col-xl-5 mt-2 mt-sm-0">
          <button class="btn btn-primary btn-block btn-sm" @click.stop="selectApp" v-if="item">
            {{ $t("integration.learnMore") }}
          </button>
          <template v-else>
            <button class="btn btn-secondary btn-block btn-sm" disabled="disabled" v-if="comingSoon">
              {{ $t("integration.learnMore") }}
            </button>
            <button class="btn btn-secondary btn-block btn-sm empty" disabled="disabled" v-else></button>
          </template>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import Tag from "./Tag";
export default {
  name: "AppItem",
  components: {
    Tag
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return null;
      }
    },
    comingSoon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    metadata() {
      if (!this.item || !this.item.data_attr) return {};
      let metas;
      try {
        metas = JSON.parse(this.item.data_attr);
      } catch (err) {
        // console.error(err);
        metas = {};
      }
      return metas;
    },
    bundle() {
      if(this.item && this.item.features && this.item.features.length) {
        return this.item.features.map(e => ({name: e}))
      }
      if (!this.metadata || !this.metadata.bundle) return {};
      let bundle;
      try {
        bundle = JSON.parse(this.metadata.bundle);
      } catch (err) {
        // console.error(err);
        bundle = {};
      }
      return bundle;
    }
  },
  methods: {
    selectApp() {
      let item = { ...this.item };
      item.metadata = this.metadata;
      item.bundle = this.bundle;
      this.$emit("select", item);
    },
    selectTag(item) {
      this.$emit("tag", item);
    }
    // removeTag(item) {
    //   this.$emit("tag:remove", item);
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/core/themes/partials/_animation.scss";

.app-item {
  border-radius: 3px;
  border: solid 1px rgba(238, 238, 238, 1);
  background: #fff;
  display: flex;
  flex-direction: column;
  flex: 1;

  .thumbnail {
    overflow: hidden;
    display: flex;
    width: 120px;
    height: 120px;
    min-width: 120px;
    min-height: 120px;
    img {
      width: 100%;
    }

    .img-empty {
      border: none;
      margin: -1px;
      width: 100%;
      border-radius: 0;
      &:empty:after {
        content: "";
        display: block;
        padding-bottom: 100%;
      }
    }
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;

    > .content {
      // max-height: 65px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    > h6:empty {
      height: 20px;
      width: 50%;
      border-radius: 20px;
      @include skeleton("light");
    }

    > .paragraph {
      height: 16px;
      width: 100%;
      border-radius: 16px;
    }
  }

  .rating {
    color: $cYellow;
    & + .btn {
      font-size: 12px;
      line-height: 18px;
      min-width: 120px;
    }

    &-points {
      color: $black1;
      &:not(.omit-empty):empty {
        height: 14px;
        border-radius: 14px;
        width: 70px;
        @include skeleton("light");
      }
    }
  }

  .footer {
    .empty.btn {
      border-radius: 5px;
      min-height: 30px;
    }
  }

  .empty {
    @include skeleton("light");
  }
  .bundles {
    display: flex;
    flex-direction: column;
  }
}
</style>
